<template>
    <div class="form-wrap">

        <div class="sub-visual sub-visual--sv6">
            <v-container>
                <h2 class="sub-visual__title color-white"><span>DEMO</span></h2>
            </v-container>
        </div>

        <section class="sub-section">
            <v-container>

                <h6 class="page-text-lg font-weight-bold text-center mb-30 mb-lg-52">
                    {{ settings.demo }}
                </h6>

                <p class="text-right page-text-sm line-height-1 mb-4 mb-lg-8"><span style="color:#ff2d2d">*</span> This is a required data entry</p>
                <div class="table-style table-style--default">
                    <div class="table-style__row">
                        <div class="table-style__th">Name <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.name" v-bind="$attrs" placeholder="Name" outlined hide-details clearable />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">Contact information <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <v-row align="center" class="row--small">
                                        <v-col>
                                            <v-select v-model="phone1" :items="prependPhones" v-bind="$attrs" placeholder="contact information" outlined hide-details @input="() => phoneNumberJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-text-field v-model="phone2" v-bind="$attrs" maxlength="4" outlined hide-details @input="() => phoneNumberJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-text-field v-model="phone3" v-bind="$attrs" maxlength="4" outlined hide-details @input="() => phoneNumberJoin()"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">Email <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <v-row align="center" class="row--small">
                                        <v-col>
                                            <v-text-field v-model="email1" v-bind="$attrs" placeholder="Email" outlined hide-details @input="() => emailJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">@</v-col>
                                        <v-col>
                                            <v-text-field v-model="email2" v-bind="$attrs" outlined hide-details @input="() => emailJoin()"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-select v-model="email3" v-bind="$attrs" persistent-hint :items="prependEmails" item-text="text" item-value="value" outlined hide-details @input="email2 = email3"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">Company name <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.companyName" v-bind="$attrs" placeholder="Company name" outlined hide-details clearable/>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">Environment of Use <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.os" v-bind="$attrs" placeholder="[Windows], [Linux{CentOS, Ubuntu}].." outlined hide-details clearable/>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">WEB Servers /WAS Type <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-text-field v-model="demo.server" v-bind="$attrs" placeholder="WEB Servers /WAS Type" outlined hide-details clearable/>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">Operating agency required <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-radio-group v-model="demo.need" row hide-details>
                                            <v-radio label="Required" value="필요" color="primary"></v-radio>
                                            <v-radio label="Not required" value="불필요" color="primary"></v-radio>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="table-style__row">
                        <div class="table-style__th">Other inquiries <span style="color:#ff2d2d">*</span></div>
                        <div class="table-style__td">
                            <v-row class="row--x-small">
                                <v-col cols="12">
                                    <div class="my-6px">
                                        <v-textarea rows="9" v-model="demo.content" outlined hide-details></v-textarea>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
                
                <div class="mt-30 mt-lg-60 text-center">
                    <v-btn x-large color="primary" @click="submit">To apply for</v-btn>
                </div>
            </v-container>
        </section>

    </div>
</template>
<script>

import api from "@/api";

export default {
    components: {
    },
    data(){
        return {

            demo:{
                name: null,
                phone: null,
                email: null,
                companyName: null,
                os: null,
                server: null,
                need: null,
                content: null
            },

            phone1: "010",
            phone2: null,
            phone3: null,

            email1: null,
            email2: null,
            email3: null,

            agree: false,

            prependPhones: [
                { text: "010", value: "010" },
                { text: "011", value: "011" },
                { text: "016", value: "016" },
                { text: "017", value: "017" },
                { text: "019", value: "019" }
            ],
            prependEmails: [
                { text: ":: Direct input ::", value: null },
                { text: "naver.com", value: "naver.com" },
                { text: "gmail.com", value: "gmail.com" },
                { text: "daum.net", value: "daum.net" },
                { text: "hanmail.net", value: "hanmail.net" },
            ],
            settings: null,

            filter: {
                code: "en"
            }
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        },
        validate(){
            try{
                let demo = this.demo
                if(!demo.name) throw new Error('Please enter your name')
                if(!demo.phone || !this.phone1 || !this.phone2 || !this.phone3) throw new Error('Please enter your contact information')
                if(!demo.email || !this.email1 || !this.email2) throw new Error('Please enter your Email')
                if(!demo.companyName) throw new Error('Please enter your Company name ')
                if(!demo.os) throw new Error('Please enter your Environment of Use')
                if(!demo.server) throw new Error('Please enter your  WEB server')
                if(demo.need === null) throw new Error('Please select whether you need a Operating agency')
                if(!demo.content) throw new Error('Please enter Other inquiries')
                // if(!this.agree) throw new Error('개인정보 수집·이용에 동의해주세요')
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        async submit(){
            if(this.validate()){
                let demo = this.demo
                let { success } = await api.v1.message.post({ demo })
                if(success){
                    alert('Done.')
                    this.$router.push('/')
                }
            }
        },
        phoneNumberJoin(){
            this.demo.phone = `${this.phone1}-${this.phone2}-${this.phone3}`
        },
        emailJoin(){
            this.demo.email = `${this.email1}@${this.email2}`
        },
    },
    watch:{
        email3(){
            this.emailJoin()
        }
    }
}
</script>